import React, { Fragment } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { IMAGE_GALLERY } from '../../../Constant';
import HeaderCard from '../../Common/HeaderCard';
import GalleryImages from '../GalleryImages';

const ListOfImage = () => {
  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <HeaderCard title={IMAGE_GALLERY} />
          <CardBody className='gallery my-gallery row'>
            <GalleryImages />
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default ListOfImage;
